<template>
  <app-icon
    name="arrow-right"
    class="transaction-arrow-right-icon"/>
</template>

<style scoped>
.transaction-arrow-right-icon {
  color: var(--color-fire);
  min-width: var(--space-3);
}
</style>
